import { useQuery } from "react-query";

import { PantryService } from "../api/public";

export const getUserPantryIdsQueryKey = () => {
  return ["pantryIds"];
};

export const useUserPantryIdsQuery = () => {
  return useQuery(getUserPantryIdsQueryKey(), async () => {
    const response = await PantryService.pantryListUserRawMaterialIds();
    return response.data ?? [];
  });
};
